import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { OrderService } from '../_ecomservices/order.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/_services/notification.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import * as _ from 'lodash';
import { DatePipe, Location } from '@angular/common';



@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {

  order_form = new FormGroup({
    id: new FormControl(null),
    customer_id: new FormControl(''),
    bill_no: new FormControl(''),
    bill_amt: new FormControl(''),
    coupon_code: new FormControl(''),
    discount_amt: new FormControl(''),
    tax_total: new FormControl(''),
    shipping_total: new FormControl(''),
    r_off: new FormControl(''),
    net_amt: new FormControl(''),
    pay_amt: new FormControl(''),
    paid_amt: new FormControl(''),
    note: new FormControl(''),
    order_date: new FormControl(''),
    status: new FormControl(''),
    order_status: new FormControl('', [Validators.required]),
    shipping_status: new FormControl(''),
    created_at: new FormControl(''),
  });

  @ViewChild("ItemCode") _itemCode: ElementRef;
  @ViewChild("Qty") _quantity: ElementRef;
  productForm = new FormGroup({
    ItemCode: new FormControl('', Validators.required),
    ItemId: new FormControl('', Validators.required),
    Qty: new FormControl('', [Validators.required, Validators.min(0)]),
    Crate: new FormControl('', [Validators.required, Validators.min(0)]),
    Price: new FormControl('', [Validators.required, Validators.min(0)]),
    SubTotal: new FormControl('', Validators.required),
  });

  order_status_list: any = [];
  order_data: any = null;
  order_item_list: any = [];
  order_id: any = 0;

  isAddOrderItem: boolean = false;
  isEditOrderItem: boolean = false;

  constructor(
    public datePipe: DatePipe,
    private location: Location,
    private route: ActivatedRoute,
    private titleService: Title,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public orderService: OrderService) {
  }

  ngOnInit() {
    this.titleService.setTitle('Order Details');
    this.route.paramMap.subscribe(params => {
      this.order_id = params.get('id');
      this.loadOrderDetails(this.order_id);
    });
  }

  loadOrderDetails(order_id) {
    var result = this.orderService.get_order_details(order_id).subscribe(data => {
      if (data['status']) {
        this.order_status_list = data['order_status_list'];
        this.order_data = data['order_data'];
        data['order_data'].order_status = Number(data['order_data'].order_status);
        this.order_form.patchValue({
          id: data['order_data'].id,
          customer_id: data['order_data'].customer_id,
          bill_no: data['order_data'].bill_no,
          bill_amt: data['order_data'].bill_amt,
          coupon_code: data['order_data'].coupon_code,
          discount_amt: data['order_data'].discount_amt,
          tax_total: data['order_data'].tax_total,
          shipping_total: data['order_data'].shipping_total,
          r_off: data['order_data'].r_off,
          net_amt: data['order_data'].net_amt,
          pay_amt: data['order_data'].pay_amt,
          paid_amt: data['order_data'].paid_amt,
          note: data['order_data'].note,
          order_date: this.datePipe.transform(data['order_data'].created_at, 'yyyy-MM-dd'),
          status: data['order_data'].status,
        });
        console.log(typeof data['order_data'].allotment_vehicle);
        // this.order_form.setValue(_.omit(data['order_data'], 'company_id', 'shipping_info', 'customer', 'order_items', 'pay_method_id', 'payment_method', 'order_payments', 'order_trackings', 'order_return', 'last_updated_by', 'updated_at', 'deleted_at'));
        this.order_item_list = data['order_data']['order_items'];
        console.log(this.order_item_list);

        console.log('order_trackings => ', data['order_data']['order_trackings']);
        this.order_form.controls['order_status'].setValue(data['order_data']['order_status']);
      }
      else {
        this.notificationService.error(data['error_message']);
      }
    });
  }

  onUpdateOrderStatusFormSubmit() {
    console.log(this.order_form.value)
    if (this.order_form.valid) {
      // this.loading.spin$.next(true);
      this.orderService.update_order_status(this.order_form.value).subscribe(data => {
        console.log(data);
        if (data['status']) {
          this.notificationService.success(data['message']);
          this.loading.spin$.next(false);
        }
        else {
          this.notificationService.error(data['message']);
          this.loading.spin$.next(false);
        }
      });
    }
  }

  onAddProduct() {
    if (this.productForm.valid) {
      if (this.productForm.value.Qty <= 0) {
        this.notificationService.warn('Quantity must be greater than Zero!!');
        this._quantity.nativeElement.focus();
      }
      else if (this.productForm.value.SubTotal != (this.productForm.value.Price * this.productForm.value.Qty)) {
        this.notificationService.error('Error found in price calculation!!');
      }
      else {
        // this.loading.spin$.next(true);
        // let product_row = this.saleProductList.find(x=> x.ID === this.productForm.value.ItemId);
        // var product = {
        //   ItemId: this.productForm.value.ItemId,
        //   ItemCode: product_row.ItemCode,
        //   Qty: this.productForm.value.Qty,
        //   Crate: this.productForm.value.Crate,
        //   Unit: product_row.Unit,
        //   MRP: product_row.SalePrice,
        //   Price: this.productForm.value.Price,
        //   SubTotal: (this.productForm.value.Price * this.productForm.value.Qty).toFixed(2),
        // };
        // const dup_index = this.products.findIndex(x => x.ItemId === this.productForm.value.ItemId);
        // if (dup_index !== undefined && dup_index!=-1) 
        // {
        //   this.notificationService.error('This product is already added!!');
        //   this.loading.spin$.next(false);
        // }
        // else
        // {
        //   this.products.push(product);
        //   this.product_unit = null;
        //   this.product_stock = null;
        //   this.productForm.reset();
        //   this.filteredProducts = [];
        //   this._itemCode.nativeElement.focus();
        //   //console.log(this.products);
        //   this.onCalculateBilling();        
        //   this.notificationService.success('Product added successfully!!');
        //   this.loading.spin$.next(false);
        // }
      }
    }
  }

  onRemoveProduct(id) {
    const index = this.order_item_list.findIndex(x => x.product_id === id);
    if (index !== undefined) {
      // Update Product Qty
      // this.products.splice(index, 1);
      // this.onCalculateBilling();
      this.notificationService.warn('Product removed successfully!!');
    }
  }

  onAddOrderItem() {
    this.isAddOrderItem = true;
  }

  onEditOrderItem() {
    this.isEditOrderItem = true;
    console.log(this.isEditOrderItem);
  }

  onChangeItemQty(itemData) {
    console.log(itemData);
    itemData.total_price = itemData.quantity * itemData.price;
    this.calculateOrderTotal();
  }

  onUpdateOrderItems() {
    let orderId = this.order_form.value.id;
    console.log(orderId);
    console.log(this.order_item_list);
    let qtyError = false;
    let createError = false;
    this.order_item_list.forEach(element => {

      if (element.quantity === null || element.quantity === undefined || element.quantity === "" || element.quantity < 0) {
        qtyError = true;
      }
      if (element.crate === null || element.crate === undefined || element.crate === "" || element.crate < 0) {
        createError = true;
      }
    });

    if (qtyError || createError) {
      this.notificationService.warn('Invalid product quantity or crate, Please cross check this')
    }
    else {
      this.orderService.update_order_items(this.order_form.value, this.order_item_list).subscribe(data => {
        console.log(data);
        if (data['status']) {
          this.isEditOrderItem = false;
          this.notificationService.success(data['message']);
        } else {
          this.notificationService.error(data['error_message']);
        }
      })
    }


  }

  calculateOrderTotal() {
    let net_amt = this.order_item_list.reduce((total, item) => {
      return parseFloat(total) + parseFloat(item.total_price || 0);
    }, 0);
    this.order_data.net_amt = net_amt;
    this.order_form.controls['net_amt'].setValue(net_amt);
  }

  goBack() {
    this.location.back();
  }


}
